/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![SlashRetryIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABzklEQVR4nN1VOy8FURBeiUej8YrCHyAqreZ2bOzOmbmSY+ZKtLdCIRqtkFwdfoqIeDbEPxD/AI1HoSNBZu1h797X3nUrJznJ2T0z88188zie92+WtbbXEO8A8r0h+cyzgfjOkFTUVg2AXuQ1bGp3pQbgL56b9EZ5qBdBGwb4NEkDkCykZf4C8A4gk06vUCh0G+KbjgEAym6VXlFW68nlBOBnoqUhpxMEiwOA/NgxACBertbh/UaybQMAym25XO5x8uF8aRyQ3zoHUBS/Sh7lqIn8R3sAKEdJWQVz9W5Ito2RqTAsDVtr+xF5OiSeaQfgvV5ZAvKhtXbQy7oac897Vd6jrADxged5XS4aID7WCgOUV0NyjrgwCyTXBvmqKQCgPCW91LN67/4Zks1WuWsOQLVlCShbekYszcURvhniNc1BENgxINlIVldDAC1L5dvdE/FEpGhkKqKG5CxuvrUf+pSWrBHoAHN3vu/36YDT/66TlT79Vs9/bCBfpWxc/ibv+7Fo2c3W2v6YruckYJYqyvTgIPJ07O1FmqIMT6ZUWkTyocmNIw5dkkPkdQAZ9a0dic7EL+kCybWiLs44GPODFCXQitKxHSUe5UQbzQl8AWoGiW3EXZMeAAAAAElFTkSuQmCC)
 */
export const SlashRetryIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        d="M19 16a3 3 0 1 0 1.98 5.25 1 1 0 0 1 1.33 1.5A4.99 4.99 0 0 1 14 19a5 5 0 0 1 8-4 1 1 0 0 1 2 0v3a1 1 0 0 1-1 1h-3a1 1 0 1 1 0-2h1.24A3 3 0 0 0 19 16Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
      <path
        fillRule="evenodd"
        d="M22 11.82c0 .2-.14.4-.33.49h-.02a.58.58 0 0 1-.44.05 6.99 6.99 0 0 0-8.83 8.9c.11.36-.13.74-.5.74H5a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v6.82ZM17.57 5c.2 0 .31.2.22.37l-7.57 13.25a.75.75 0 0 1-.66.38H6.43c-.2 0-.31-.2-.22-.37l7.57-13.25a.75.75 0 0 1 .66-.38h3.13Z"
        clipRule="evenodd"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
    </svg>
  );
};
